import { IQuestionCategory } from './question-category.model';

export enum AttendanceStatus {
	Present = 'present',
	Absent = 'absent',
	Unknown = 'unknown',
}

export interface IAttendance {
	id?: string;
	status: AttendanceStatus;
	question: string;
	QuestionCategories: Array<IQuestionCategory>;
}
